<!-- 彩种页头部组件 -->
<template>
    <div class="head">
        <!-- 第一行 -->
        <van-row type="flex" justify="space-between" class="row1">
            <van-col span="11">
                <h4 class="font1 mb5">第{{ data.openIssueName }}期</h4>
                <h6 class="font4">{{ data.issueDay }}({{ data.weekDisplayName }})</h6>
            </van-col>
            <van-col span="13" class="col-top algin-right">
                <div class="my-tag font3" @click="goHistory">
                    <van-icon name="video" />
                    回放
                </div>
                <div class="my-tag font3" @click="goChart">
                    走势图
                    <van-icon name="arrow" />
                </div>
            </van-col>
        </van-row>
        <!-- 内容行 -->
        <van-row type="flex" justify="space-between" class="row2">
            <van-col span="20" class="col-center">
                <span v-for="value in data.winNumbers" class="win-number">{{ value }}</span>
            </van-col>
            <van-col span="4" class="col-center algin-right">
                <van-icon name="arrow" color="#6d6d6d" />
            </van-col>
        </van-row>
        <!-- 底部行 -->
        <van-row type="flex" justify="space-between" class="item-row">
            <van-col span="24" class="col-center count-down">
                第<span class="font1">{{ data.currIssueName }}</span>期截止销售时间
                <van-count-down :time="remainingSeconds" class="time">
                    <template #default="timeData">
                        <span class="block">{{ timeData.hours }}</span>
                        <span class="colon">:</span>
                        <span class="block">{{ timeData.minutes }}</span>
                        <span class="colon">:</span>
                        <span class="block">{{ timeData.seconds }}</span>
                    </template>
                </van-count-down>
            </van-col>
        </van-row>
    </div>
</template>

<script>
import dayjs from 'dayjs';
export default {
    name: 'LotteryHead',
    data() {
        return {
            time: 0,
        };
    },
    props:['data'],
    computed:{
        // 截止剩余秒数
        remainingSeconds(){
            const seconds = dayjs(this.data.endTime).valueOf() - Date.now()
            if(seconds < 0) return 0
            return seconds
        },
    },
    methods:{
        // 打开走势页
        goChart(){
            this.$router.push({
                path:'/iframe',
                query:{
                    title: '走势图',
                    iframeUrl: this.data.chartUrl
                }
            })
        },

        // 打开回顾页
        goHistory(){
            this.$router.push({
                path:'/iframe',
                query:{
                    title: '开奖回顾',
                    iframeUrl: this.data.historyUrl
                }
            })
        }
    }
}
</script>

<style scoped>
.head {
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.row1 {
    height: 32px;
}

.row2 {
    height: 32px;
    margin: 8px auto;
}

h6 {
    color: #969799;
}

.my-tag {
    padding: 5px 10px;
    background: #F1F1F1;
    border-radius: 50px;
    margin-left: 5px;
}

.win-number {
    display: inline-block;
    height: 30px;
    width: 30px;
    text-align: center;
    line-height: 30px;
    background: #ee0a24;
    /* background-image: linear-gradient(to top, #feada6 0%, #f5efef 100%); */
    /* background-image: linear-gradient(to right, #f78ca0 0%, #f9748f 19%, #fd868c 60%, #fe9a8b 100%); */
    border-radius: 20px;
    color: #fff;
    margin-right: 10px;
}

.time {
    margin-left: 5px;
}

.colon {
    display: inline-block;
    margin: 0 4px;
    color: #ee0a24;
}

.block {
    display: inline-block;
    width: 22px;
    color: #fff;
    font-size: 13px;
    text-align: center;
    background-color: #ee0a24;
    border-radius: 3px;
}
</style>